module.exports = __webpack_public_path__ + "media/images/introduce_1-f409873481f009a31576625c7e57f299.jpg";